<template>
  <ActiveScreen v-if="hasActiveGame" />
  <InactiveScreen v-if="!hasActiveGame" />
</template>

<script>
import InactiveScreen from "@/components/InactiveScreen.vue";
import ActiveScreen from "@/components/ActiveScreen.vue";

export default {
  name: "ClawView",
  components: {
    InactiveScreen,
    ActiveScreen,
  },
  data: () => ({
    activePlay: false,
  }),
  computed: {
    hasActiveGame() {
      const activeGameDiff = this.$store.getters.getActiveGameDiff;
      // Return true if game activity is within last 14 seconds (active game)
      // Return false if no data or game is older than 14 seconds (inactive)
      return activeGameDiff !== null && activeGameDiff < 14;
    },
  },
  created() {
    this.timer = setInterval(this.getActivePlay, 2000);
  },
  methods: {
    getActivePlay() {
      this.$store.dispatch("getActiveGame");
    },
  },
  beforeUnmount() {
    clearInterval(this.timer);
  },
};
</script>

<style>
h1 {
  font-size: 150px;
  color: #26231d;
  padding-bottom: 20px;
}
img {
  padding-bottom: 20px;
}
.outer {
  display: flex;
  align-items: center;
}
.center {
  margin: auto;
  padding: 10px;
}
.screen {
  /* background: url("~@/assets/home_bg.png") no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  height: 100%; */
  overflow: hidden; /* Hide scrollbars */
}
</style>
